var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mission"}},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('mission.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('mission.subtitle')))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }